import { forwardRef } from 'react';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { ChipElement } from 'framework/chip/elements';
import { useChipTheme } from 'framework/chip/hooks/useChipTheme';
import { Icon } from 'framework/Icon';
import { colors } from 'framework/theme/constants/colors';

import { EMPTY_FUNCTION } from '../../constants';
import { useFontTheme } from '../theme/hooks/useFontTheme';

import { ChipProps } from './types';

import cn from './Chip.module.scss';

export const Container = forwardRef<HTMLButtonElement, ChipProps>(
  ({ id, children, width, clear = false, onClick = EMPTY_FUNCTION, theme }, ref) => {
    const font_theme = useFontTheme(theme?.font);
    const chip_theme = useChipTheme(theme?.chip);

    return (
      <ChipElement
        ref={ref}
        id={id}
        className={classNames('transition', cn.chip, { [cn.clear]: clear })}
        onClick={onClick}
        theme={{ font: font_theme, chip: chip_theme }}
        clear={clear}
        style={{ minWidth: width, maxWidth: width }}
      >
        {children}
        {clear && (
          <Icon
            icon={faXmark}
            width="fit-content"
            size="11px"
            theme={{ normal: colors.purple[9], hover: colors.purple[8] }}
          />
        )}
      </ChipElement>
    );
  }
);
